import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api, Code } from '@.api';
import { useId } from '@.hooks';
import { Table, TableColumn, TableRow } from '@.partials';
import { Layout } from '@/Components/Layouts';
import { Button } from '@/Components/UI';
import { LinkHelper } from '@/Services';
import { ParentCompanyResource } from '@/Types/ParentCompany';

import S from './ParentCompanyDetailPage.module.scss';

export const ParentCompanyDetailPage = () => {
    const navigate = useNavigate();

    const [parentCompany, setParentCompany] = useState<ParentCompanyResource | null>(null);

    useId((id) => {
        const fetch = async () => {
            const response = await Api.parentCompany().getById(id);

            if (response.code !== Code.Success) {
                throw response;
            }

            setParentCompany(response.data.parent_company);
        };

        void fetch();
    });

    const back = () => {
        navigate(LinkHelper.parentCompanies.all);
    };

    return (
        <Layout name="Parent company" breadcrumbs={[{ name: 'Parent Company' }, { name: 'Detail' }]}>
            <h1>
                View parent company detail
                {parentCompany && (
                    <Button href={LinkHelper.parentCompanies.editParentCompany(parentCompany.id)} color="brown">
                        Edit
                    </Button>
                )}
            </h1>

            {parentCompany && (
                <Table>
                    <TableRow>
                        <TableColumn bold>Name</TableColumn>
                        <TableColumn>{parentCompany.name}</TableColumn>
                    </TableRow>
                    <TableRow>
                        <TableColumn bold>Image</TableColumn>
                        <TableColumn>{parentCompany.image?.url && <img src={parentCompany.image.url} alt={parentCompany.image.name} />}</TableColumn>
                    </TableRow>
                </Table>
            )}

            <Button className={S.BackButton} onClick={back}>
                Back to all parent companies
            </Button>
        </Layout>
    );
};
